<template>
  <CommonPagesMainContainer>
    <CommonPagesLogo></CommonPagesLogo>
    <CommonPagesGreeting></CommonPagesGreeting>
    <CommonPagesFormCard>
      <Spinner :isLoading="isLoading">
        <CommonPagesForm :header="null" :message="errorMessage"> </CommonPagesForm>
      </Spinner>
    </CommonPagesFormCard>
  </CommonPagesMainContainer>
</template>

<script>
import CommonPagesMainContainer from '@/components/CommonPagesMainContainer'
import CommonPagesLogo from '@/components/CommonPagesLogo'
import CommonPagesGreeting from '@/components/CommonPagesGreeting'
import CommonPagesFormCard from '@/components/CommonPagesFormCard'
import CommonPagesForm from '@/components/CommonPagesForm'
import {mapActions} from 'vuex'

export default {
  name: 'PasswordChangeValidation',
  components: {
    CommonPagesGreeting,
    CommonPagesLogo,
    CommonPagesMainContainer,
    CommonPagesFormCard,
    CommonPagesForm
  },
  data: () => ({
    errorMessage: '',
    uuid: null,
    isLoading: true
  }),
  created() {
    this.getUUID()
    this.checkUUID()
  },
  methods: {
    ...mapActions({
      resetToken: 'auth/RESET_TOKEN'
    }),
    getUUID() {
      this.uuid = this.$route.params.uuid
    },
    checkUUID() {
      this.isLoading = true
      this.resetToken(this.uuid)
        .then(() => {
          this.isLoading = false
          this.$router.push({name: 'passwordChange'})
        })
        .catch(() => {
          this.errorMessage = 'Срок действия вашей ссылки истек'
          this.isLoading = false
        })
    }
  }
}
</script>
